import { render, staticRenderFns } from "./SearchResultItem.vue?vue&type=template&id=288ef673&scoped=true"
import script from "./SearchResultItem.vue?vue&type=script&lang=js"
export * from "./SearchResultItem.vue?vue&type=script&lang=js"
import style0 from "./SearchResultItem.vue?vue&type=style&index=0&id=288ef673&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ef673",
  null
  
)

export default component.exports